export default __webpack_public_path__ + "images/76.27b6cba.png";